import { useQuery } from '@apollo/client';

import { ADMIN_EVENT_TRANSACTIONS } from '../graphql/query/adminEventTransactionsQuery.graphql';

export const useAdminEventTransactionsQuery = (eventId: string | null) => {
  return useQuery(ADMIN_EVENT_TRANSACTIONS, {
    variables: { eventId: eventId ?? '' },
    skip: !eventId,
  });
};
